var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0",
    },
    [
      _c("div", [_vm._t("logo")], 2),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-lg overflow-hidden soli-round",
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }